export default __webpack_public_path__ + "static/media/package-img1.5cd10b56.jpg";